import React from "react"
import { Popover } from "antd"
import { intersperse } from "../../../utilities/misc"
import PRSValidationBadge from "../../badges/PRSValidationBadge/PRSValidationBadge"

// styles
import "./PrsValidationsWithCount.scss"

const iconProps = {
  info: {
    color: "#18669E",
    icon: "info-circle",
  },
  warning: {
    color: "#ECB81E",
    icon: "exclamation-triangle",
  },
  error: {
    color: "#D7542C",
    icon: "do-not-enter",
  },
}

const PrsValidationsWithCount = ({ value, hasCount = true }) => {
  const [formattedValidations, setFormattedValidations] = React.useState({
    errors: { count: 0, msgs: [] },
    warnings: { count: 0, msgs: [] },
    notes: { count: 0, msgs: [] },
  })

  const renderValidationCell = React.useMemo(() => {
    if (value?.length > 0) {
      let errors = { count: 0, msgs: [] }
      let warnings = { count: 0, msgs: [] }
      let notes = { count: 0, msgs: [] }
      let items = []

      value.forEach((item) => {
        let newItem = { ...item }

        if (hasCount === false) {
          newItem = {
            count: 1,
            severity: item.type,
            message: item.text,
          }
        }

        if (newItem.severity === "ERROR") {
          errors.count += newItem.count
          errors.msgs.push(newItem)
        } else if (newItem.severity === "WARNING") {
          warnings.count += newItem.count
          warnings.msgs.push(newItem)
        } else {
          notes.count += newItem.count
          notes.msgs.push(newItem)
        }
      })

      if (errors.msgs.length > 0) {
        items.push(
          <PRSValidationBadge
            key={"sl-errors"}
            type={"error"}
            num={errors.count}
          />
        )
      }
      if (warnings.msgs.length > 0) {
        items.push(
          <PRSValidationBadge
            key={"sl-warnings"}
            style={{ marginLeft: 4 }}
            type={"warning"}
            num={warnings.count}
          />
        )
      }
      if (notes.msgs.length > 0) {
        items.push(
          <PRSValidationBadge
            key={"sl-notes"}
            style={{ marginLeft: 4 }}
            type={"note"}
            num={notes.count}
          />
        )
      }

      items = intersperse(items, ", ")

      setFormattedValidations({
        errors,
        warnings,
        notes,
      })

      return items
    }
  }, [value, hasCount])

  const getStatus = React.useMemo(() => {
    let statuses = []

    const { errors, warnings, notes } = formattedValidations

    if (errors.msgs.length > 0) {
      statuses.push({
        type: "Error(s)",
        icon: (
          <i
            className={`fas fa-${iconProps.error.icon}`}
            style={{ color: iconProps.error.color, fontSize: ".75rem" }}
          />
        ),
        messages: errors.msgs.map((msg) => msg),
      })
    }
    if (warnings.msgs.length > 0) {
      statuses.push({
        type: "Warning(s)",
        icon: (
          <i
            className={`fas fa-${iconProps.warning.icon}`}
            style={{ color: iconProps.warning.color, fontSize: ".75rem" }}
          />
        ),
        messages: warnings.msgs.map((msg) => msg),
      })
    }
    if (notes.msgs.length > 0) {
      statuses.push({
        type: "Note(s)",
        icon: (
          <i
            className={`fas fa-${iconProps.info.icon}`}
            style={{ color: iconProps.info.color, fontSize: ".75rem" }}
          />
        ),
        messages: notes.msgs.map((msg) => msg),
      })
    }

    return statuses
  }, [formattedValidations])

  return (
    <div className="prs-validation-cell-renderer-container">
      <Popover
        content={
          <div className="prs-upload-status-popover-container">
            {getStatus?.map((status, index) => {
              return (
                <div
                  style={{ paddingRight: 24 }}
                  key={index}
                >
                  <div style={{ fontWeight: "600" }}>
                    {status.icon} {status.type}
                  </div>
                  <ul>
                    {status.messages.map((message, index) => {
                      return (
                        <li key={index}>
                          <div>
                            <div>
                              {message.count <= 1 ? "" : `(${message.count}) `}
                              {message?.message}
                            </div>
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              )
            })}
          </div>
        }
      >
        {renderValidationCell}
      </Popover>
    </div>
  )
}

export const prsValidationsWithCountGridExport = (messages) => {
  if (!messages || messages.length === 0) return ""
  let errors = 0
  let warnings = 0
  let notes = 0

  messages.forEach((item) => {
    if (item.severity === "ERROR") {
      errors += item.count
    } else if (item.severity === "WARNING") {
      warnings += item.count
    } else {
      notes += item.count
    }
  })
  return `${errors} Error(s), ${warnings} Warning(s), ${notes} Note(s)`
}

export default PrsValidationsWithCount
